import script from "./sidebar-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar-nav.vue?vue&type=script&setup=true&lang=js"

import "./sidebar-nav.vue?vue&type=style&index=0&id=680b2fb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680b2fb7"]])

export default __exports__